module.exports = __webpack_public_path__ + "img/Hippikon64_ua.ec8796c4.webp";